import React, { useEffect, useState, useRef } from "react";
import { FromatNumberVIE, Rounding, FormatDateYMD } from "../../../utils/format";
import { getCartInfo, actionCart, getvalidate, saveStore, saveShipping, saveTimeReceive, getLocaltionStoreByLatLog, updateAddressCart, defaultAddressCart,updateNote } from "../../../service/cartService";
import { getProvince, getDistrict, getWard } from '../../../service/locationService';
import { updateAddress, getAddress } from "../../../service/accountService";
import { navigate } from "gatsby";
import { calculateSum } from "../../../helpers/general";
import { toast } from "react-toastify";
import { geocode, RequestType } from "react-geocode";
import PaymentMobile from "./payment";
import ComplateOrderMobile from "./complateorder";
import ListDeliveryMobile from "./list-delivery";
import { isAuth } from "../../../helpers/general";
import "./cartitem.css";
import { ResponsiveSliderTop } from "../../../utils/constant";
import Carousel from "react-multi-carousel";
const CartItems = (props) => {
    if (isAuth === false) {
        window.location.href = '/dang-nhap.html';
    }
    const goBack = () => {
        window.history.back();
    };
    let [cartInfoItems, setCartInfoItems] = useState("");
    const [tab, setTab] = useState('cart');
    const [codeShipping, setCodeShipping] = useState('');
    const [isCheckPayment, setIsCheckPayment] = useState(false);
    const [isDeliveryFat, setDeliveryFat] = useState(false);
    const [hours, setHours] = useState();
    const callbackFunction = (childData) => {
        setIsCheckPayment(childData)
    };
    const cartInfo = () => {
        try {
            getCartInfo(window.localStorage.getItem('key')).then((response) => {
                if (response.status === 200) {
                    setCartInfoItems(cartInfoItems[0]?.shipping?.item?.code);
                    setLat(cartInfoItems[0]?.shipping?.address?.location?.latitude);
                    setLong(cartInfoItems[0]?.shipping?.address?.location?.longitude)
                    //valid(1);
                }
                setCartInfoItems(response['message']);
            }, []);
        } catch (e) {
            console.log(e);
        }
    }
    const handleDelete = () => {
        closeModalDelete();
        toast.error("Xóa sản phẩm trong giỏ hàng");
        let params = {
            items: [{
                product: skuItemDelete,
                type: itemDelete.type,
                promo_code: itemDelete.promo_code,
                promo_type: itemDelete.promo_type,
                action: 'delete',
                quantity: 0
            }]
        }
        try {
            actionCart(params, window.localStorage.getItem('key')).then((response) => {
                localStorage.removeItem("itemsCart");
                localStorage.setItem('itemsCart', JSON.stringify(response['message']));
                //setModalDeleteSuccessIsOpen(true);
                //localStorage.setItem('isDeleteSuccess', true);
                cartInfo();
                props.parentCallback();
            });
        } catch (err) {
            console.log(err);
        }
        //valid(1);
        // setTimeout(() => { window.location.reload() }, 3000);
    };

    const [isReload, setIsReload] = useState(false);
    const [quantity, setQuantity] = useState(0);
    const handlePlusClick = (sku, e) => {
        var el = document.getElementById("quantity_" + sku);
        let _value = el.value;
        el.value = +_value + 1;
        //setQuantity(el.value);
        setIsReload(true);
    };
    const handleMinusClick = (sku, e) => {
        var el = document.getElementById("quantity_" + sku);
        let _value = el.value;
        if (_value > 1) {
            el.value = +_value - 1;
            //setQuantity(el.value);
            setIsReload(true);
        }
    };
    const skuRef = useRef(null);
    const quantityRef = useRef(null);
    const handleUpdate = (sku, item, quantity) => {
        // setShowButtonContinue(false);
        var el = document.getElementById("quantity_" + sku);
        let _value = +el.value;
        let params = null;
        if (item.promo_code !== '' && item.uudai !== '') {
            params = {
                items: [{
                    product: sku,
                    type: item.type,
                    action: 'update',
                    quantity: quantity,
                    promo_code: item.promo_code,
                    promo_type: item.promo_type,
                    uudai: item.uudai
                }]
            }
        } else {
            params = {
                items: [{
                    product: sku,
                    type: item.type,
                    action: 'update',
                    quantity: quantity
                }]
            }
        }

        try {
            actionCart(params, window.localStorage.getItem('key')).then((response) => {
                if (response.status === 200) {
                    cartInfo();
                    props.parentCallback();
                    // valid(1);
                }
            });
        } catch (err) {
            console.log(err);
        }
        //}

    };

    const [itemsDelevery, setItemsDelevery] = useState([]);
    const [firstItemDelivery, setFirstItemDelivery] = useState('');
    const noteOrderRef = useRef(null);
    const loadDelivery = () => {
        try {
            if (window.localStorage.getItem('key') !== '') {
                getvalidate(1, window.localStorage.getItem('key')).then((response) => {
                    setItemsDelevery(response['message'].items);
                    if (response['message']?.items?.length > 0) {
                        setFirstItemDelivery(response['message'].items[0]?.code);
                        setCodeShipping(response['message'].items[0]?.code);
                        saveDataShipping(response['message'].items[0]?.code, window.localStorage.getItem('key'));
                        if (response['message'].items[0]?.code === '30P') {
                            setDeliveryFat(true);
                            setIsPickAtStore(false);
                        }
                    }
                })
            }

        } catch (err) {
            console.error(err);
        }
    }

    const [address, setAddress] = useState([]);
    const loadAddress = async () => {
        try {
            await getAddress(window.localStorage.getItem('key')).then((response) => {
                if (response['message'].length > 0) {
                    setAddress(response['message']);
                    const currentAddress = response['message'].find(item => item.current === true);
                    setLat(currentAddress.location?.latitude);
                    setLong(currentAddress.location?.longitude);
                    setCodeWard(currentAddress.ward?.code);
                    setDistrict(currentAddress.district?.code);
                    setProvince(currentAddress.province?.code);
                    getDataStore(currentAddress.location?.latitude, currentAddress.location?.longitude, '', '', '');
                } else {
                    toast.warning("Vui lòng cập nhật địa chỉ để tiếp tục mua hàng.");
                    setTimeout(() => {
                        window.location.href = '/mobile/address-detail.html';
                    }, 3000);
                }

            })
        } catch (e) {
            console.log(e);
        }
    }
    const handleChangeAdd = () => {
        setTab('list-delivery');
        window.localStorage.setItem('tabCart', 'list-delivery');
    }

    const upDateNote =(note)=>{
        try {
            updateNote(note, window.localStorage.getItem('key')).then((response)=>{
                if(response.status === 200){
                    console.log('update thanh cong.');
                }
            })
        } catch (error) {
            console.log(error);
        }
    }
    const [showLoad, setShowLoad] = useState(false);
    const handleContinues = async () => {
        if (tab === 'cart') {
            setShowLoad(true);
            setShowButtonContinue(false);
            await getvalidate(1, window.localStorage.getItem('key')).then((response) => {
                setShowLoad(false);
                setShowButtonContinue(true);
                if (response['display'] === true) {
                    if (response['message'] === "Địa chỉ người nhận hàng không hợp lệ") {
                        toast.error("Vui lòng cập nhật địa chỉ giao hàng để mua hàng!");
                    } else {
                        toast.error(response['message']);
                    }
                    loadAddress();
                    setTab('cart');
                } else if (response['status'] == 200) {
                    setTab('delivery');
                    loadDelivery();
                    loadAddress();
                    cartInfo();
                    setShowButtonContinue(true);
                }
            })
        }
        if (tab === 'delivery') {
            // valid(3);
            if (isPickAtStore === true && ItemsStoreSelected === null) {
                toast.error('Bạn chưa chọn cửa hàng nhận hàng. Bạn vui lòng chọn cửa hàng để chuyển qua bước tiếp theo.');
                return;
            }
            if (codeShipping !== '') {
                // var el = document.getElementById("payment");
                // el.classList.add("active");
                try {
                    getvalidate(3, window.localStorage.getItem('key')).then((response) => {
                        if (response['status'] === 200) {
                            setItemsDelevery(response['message'].items);
                            setShowButtonContinue(true);
                            upDateNote(noteOrderRef.current.value);
                            setTab('payment');
                        } else {
                            toast.error(response['message']);
                            // setShowButtonContinue(false);
                            return;
                        }
        
                    })
                } catch (e) {
                    console.log(e);
                }
                
            } else {
                toast.error('Bạn chưa chọn hình thức giao hàng. Bạn vui lòng chọn hình thức giao hàng để chuyển qua bước tiếp theo.');
            }
            //window.localStorage.setItem('tabCart', 'payment');
        }
        if (tab === 'payment') {
            if (isCheckPayment === true) {
                // var el = document.getElementById("complate");
                //     el.classList.add("active");
                // setTab('complate');
                // setIsCheckPayment(false);
                valid(3);
                // setTab('complete');
                window.location.href = '/complete-order.html';
            } else {
                toast.error('Bạn chưa chọn hình thức thanh toán. Vui lòng chọn hình thức thanh toán để chuyển qua bước tiếp theo.');
            }
        }

    };
    const handleBack = () => {
        if (tab === 'cart') {
            window.localStorage.removeItem('tabCart');
            goBack();
        }
        if (tab === 'list-delivery') {
            cartInfo();
            props.parentCallback();
            loadDelivery();
            setTab('delivery');
            window.localStorage.removeItem('tabCart');
            //window.localStorage.setItem('tabCart', 'delivery')
        }
        if (tab === 'store') {
            setIsPickAtStore(true);
            setDeliveryFat(false);
            setFirstItemDelivery("");
            setTab('delivery');
        }
        if (tab === 'delivery') {
            setTab('cart');
            defaultAddressCart(null, window.localStorage.getItem('key'));
            props.parentCallback();
            window.localStorage.removeItem('tabCart');
        }
        if (tab === 'payment') {
            cartInfo();
            props.parentCallback();
            loadDelivery();
            setTab('delivery');
            //window.localStorage.setItem('tabCart', 'delivery')
        }
        if (tab === 'complete') {
            window.location.href = '/';
            window.localStorage.removeItem('tabCart');
        }
    };
    const [showButtonContinue, setShowButtonContinue] = useState(true);
    const valid = (step) => {
        setShowButtonContinue(false);
        try {
            getvalidate(step, window.localStorage.getItem('key')).then((response) => {
                if (response['status'] === 200) {
                    setItemsDelevery(response['message'].items);
                    setShowButtonContinue(true);
                } else {
                    toast.error(response['message']);
                    setShowButtonContinue(false);
                    return;
                }

            })
        } catch (e) {
            console.log(e);
        }
    };
    const [showPopup, setShowPopup] = useState(true);
    const [isPickAtStore, setIsPickAtStore] = useState(false);
    const handleShowPopup = () => {
        setDeliveryFat(false);
        setShowPopup(true);
        setIsPickAtStore(true);
        getLocaltionStoreByLatLog(cartInfoItems[0].shipping?.address?.location?.latitude, cartInfoItems[0].shipping?.address?.location?.longitude, '', '', '', window.localStorage.getItem('key')).then((response) => {
            if (response.status === 200) {
                setDataItemsStore(response.message);
                var storeChecked = response.message.filter(store => store.store?.satisfyCart === 1)[0];
                setItemsStoreSelected(storeChecked);
                setCodeShipping(storeChecked.store?.code);
                updateStore(storeChecked.store?.code, window.localStorage.getItem('key'));
                cartInfo();
                setIsShowCH(true);
            }
        });
        //getDataStore(lat, long, '', '', '');
    };
    const [itemProvinces, setItemProvince] = useState([]);
    const listProvince = () => {
        try {
            if (itemProvinces.length < 1) {
                getProvince().then((response) => {
                    setItemProvince(response['message']);
                })
            }
        } catch (e) {
            console.log(e);
        }
    };
    const [itemDistrict, setItemDistrict] = useState([]);
    const listDistrict = (id) => {
        try {
            getDistrict(id).then((response) => {
                setItemDistrict(response['message']);
            })
        } catch (e) {
            console.log(e);
        }
    };
    const [province, setProvince] = useState([]);
    const handleShowDisstrict = (e) => {
        e.preventDefault();
        let value = e.target.value;
        var index = e.target.selectedIndex;
        var optionElement = e.target.childNodes[index]
        var option = optionElement.getAttribute('data');
        if (option !== null) {
            const { region, ...rest } = JSON.parse(option);
            setProvince(rest);
            getDataStore(lat, long, '', '', rest.code);
            listDistrict(value);
        }
    }
    const handleShowDisstrict2 = (e) => {
        e.preventDefault();
        let value = e.target.value;
        var index = e.target.selectedIndex;
        var optionElement = e.target.childNodes[index]
        var option = optionElement.getAttribute('data');
        const { region, ...rest } = JSON.parse(option);
        setProvince(rest);
        listDistrict(value);
    }
    const [itemWard, setItemWard] = useState([]);
    const listWard = (id) => {
        try {
            getWard(id).then((response) => {
                setItemWard(response['message']);
            })
        } catch (e) {
            console.log(e);
        }
    };

    const [district, setDistrict] = useState([]);
    const handleShowWard = (e) => {
        e.preventDefault();
        let value = e.target.value;
        var index = e.target.selectedIndex;
        var optionElement = e.target.childNodes[index]
        var option = optionElement.getAttribute('data');
        if (option !== null) {
            setDistrict(JSON.parse(option));
            getDataStore(lat, long, '', JSON.parse(option).code, province.code);
            listWard(value);
        }
    }
    const handleShowWard2 = (e) => {
        e.preventDefault();
        let value = e.target.value;
        var index = e.target.selectedIndex;
        var optionElement = e.target.childNodes[index]
        var option = optionElement.getAttribute('data');
        if (option !== null) {
            setDistrict(JSON.parse(option));
            listWard(value);
        }

    }
    const handleShowSelectedStore = () => {

        // getStoreByLatLng(lat, long,codeWard,district,province).then((response)=>{
        //     console.log(response.message);
        //         if(+response.status === 200){
        //             setDataItemsStore(response.message);
        //             setIsShowCH(true);
        //         }
        //     });
        //Lấy địa chỉ có hàng theo lat, lng
        // getLocaltionStoreByLatLog(lat, long, window.localStorage.getItem('key')).then((response) => {
        //     if (response.status === 200) {
        //         console.log(response.message);
        //         setDataItemsStore(response.message);
        //         setIsShowCH(true);
        //     }
        // });
        getDataStore(lat, long, '', '', '');
        listProvince();
        setTab('store');
    };
    const getDataStore = (lat, lng, wardCode, districtCode, provinceCode) => {
        try {
            getLocaltionStoreByLatLog(lat, lng, wardCode, districtCode, provinceCode, window.localStorage.getItem('key')).then((response) => {
                if (response.status === 200) {
                    setDataItemsStore(response.message);
                    var storeChecked = response.message.filter(store => store.store?.satisfyCart === 1)[0];
                    if (storeChecked != null && isPickAtStore === true) {
                        setItemsStoreSelected(storeChecked);
                        setCodeShipping(storeChecked.store?.code);
                        updateStore(storeChecked.store?.code, window.localStorage.getItem('key'));
                    }
                    if (firstItemDelivery !== '' && firstItemDelivery !== null) {
                        setIsPickAtStore(false);
                    }
                    setIsShowCH(true);
                }
            });
        } catch (error) {
            console.log(error);
        }
    }
    const [ward, setWard] = useState([]);
    const addressRef = useRef(null);
    const handleChangeWard = (e) => {
        e.preventDefault();
        let value = e.target.value;
        var index = e.target.selectedIndex;
        var optionElement = e.target.childNodes[index]
        var option = optionElement.getAttribute('data');
        if (option !== null) {
            setWard(JSON.parse(option));
            let address = addressRef.current.value + "," + JSON.parse(option).name + ", " + district.name + ", " + province.name;
            getLatLong(address);
        }
    }

    const [lat, setLat] = useState(0);
    const [long, setLong] = useState(0);
    const getLatLong = (address) => {
        geocode(RequestType.ADDRESS, address, {
            key: "AIzaSyDmnRQ6OT4Dc8csLKWJ7RFF0FIu8Mb8joA"
        })
            .then((response) => {
                setLat(response?.results[0]?.geometry?.location?.lat);
                setLong(response?.results[0]?.geometry?.location?.lng);
            })
            .catch((error) => {
                console.error(error);
            });
    }
    const [isShowCH, setIsShowCH] = useState(false);
    const [dataItemsStore, setDataItemsStore] = useState([]);
    const [ItemsStoreSelected, setItemsStoreSelected] = useState(null);
    const handleGetstore = (e) => {
        e.preventDefault();
        var option = '';
        var index = e.target.selectedIndex;
        var optionElement = e.target.childNodes[index]
        option = optionElement.getAttribute('data');
        try {
            if (option !== '') {
                // getLocaltionStore(option, window.localStorage.getItem('key')).then((response) => {
                //     if (response.status === 200) {
                //         console.log(response);
                //         setDataItemsStore(response['message']);
                //         setIsShowCH(true);
                //     }
                // });
                getDataStore(lat, long, option, district.code, province.code);
            }

        } catch (e) { console.log(e); }
    };
    const [codeWard, setCodeWard] = useState('');
    const handleGetCodeWWard = (code, item) => {
        setCodeWard(code);
        setItemsStoreSelected(item);
    };
    const handleUpdateStore = () => {
        if (codeWard !== '') {
            setCodeShipping(codeWard);
            updateStore(codeWard, window.localStorage.getItem('key'));
            setIsPickAtStore(true);
            setDeliveryFat(false);
            setFirstItemDelivery("");
            setTab("delivery");
        }
    };
    const updateStore = (code, token) => {
        try {
            saveStore(code, token).then((response) => {
                cartInfo();
                //setItemsStoreSelected(response["message"]);
            });
        } catch (e) { console.log(e); }
    }

    const handleDeliveryFat = (code) => {
        setCodeShipping(code);
        setDeliveryFat(true);
        setShowPopup(false);
        setIsPickAtStore(false);
        saveDataShipping(code, window.localStorage.getItem('key'));
    }
    const handleClick = (code) => {
        setDeliveryFat(false);
        setShowPopup(false);
        setCodeShipping(code);
        setIsPickAtStore(false);
        saveDataShipping(code, window.localStorage.getItem('key'));
    }

    const saveDataShipping = (code, token) => {
        try {
            saveShipping(code, token).then((reponse) => {
                cartInfo();
            });
        } catch (e) {
            console.log(e);
        }
    }

    const [activeSelectDate, setActiveSelectDate] = useState(0);
    const [activeSelectDateText, setActiveSelectDateText] = useState('');
    const [day, setDay] = useState('');
    const handleDay = (day, text) => {
        const time = new Date(Date.now());
        let _day = FormatDateYMD(time, day);
        setDay(_day);
        setActiveSelectDate(day);
        setActiveSelectDateText(text);
    }
    const [activeSelectTime, setActiveSelectTime] = useState('');
    const [activeSelectTimeText, setActiveSelectTimeText] = useState('');
    const [timeSelected, setTimeSelected] = useState('');
    const [timeSelectedText, setTimeSelectedText] = useState('');
    const handleTime = (timeSelected, text) => {
        console.log(timeSelected);
        setTimeSelectedText(text);
        const time = new Date(Date.now());
        let _day = FormatDateYMD(time, 0);
        if (day === '') {
            setDay(_day);
        }
        setActiveSelectTime(timeSelected);
        setActiveSelectTimeText(text);
        setTimeSelected(timeSelected + ':00:00')
    }
    const handleSaveTime = () => {
        const time = new Date(Date.now());
        let _day = FormatDateYMD(time, 0);
        let _time = _day + ' ' + timeSelected;
        if (_day !== '' && timeSelected !== '') {
            saveTimeReceive(_time, window.localStorage.getItem('key')).then((response) => {
                setModalPickTimeIsOpen(false);
            });
        }
    }
    var timeShipping = [];
    const returnHoursShipping = () => {
        const timeStart = new Date(Date.now());
        const timeEnd = new Date(Date.now());
        timeEnd.setHours(23, 59, 59, 999);
        var _diff = Rounding(Math.abs(timeStart.getTime() - timeEnd.getTime()) / 3600000, 0);
        for (var i = 1; i < _diff - 3; i++) {
            let _time = timeStart.getHours() + i;
            timeShipping.push(_time);
        }
        setHours(timeShipping);
    }

    const [isUpdateShipping, setUpdateShipping] = useState(false);
    const handleUpdateShipping = () => {
        listProvince();
        setUpdateShipping(!isUpdateShipping);
    }
    const location = {
        latitude: lat,
        longitude: long
    };
    const phoneNumberRegex = /^(?:\+84|0)([1-9]\d{8})$/;

    const handleAddAddress = async (e) => {
        e.preventDefault();
        const data = new FormData(e.target);
        let _name = data.get('name');
        let _phone = data.get('phone');
        let _address = data.get('address');
        let _location = data.get('rdio_location');
        let date_raw = new Date().toISOString().slice(0, 23);
        if (_name === "" || _phone === "" || _address === "" || province === "" || district === "" || ward === "" || _location === "") {
            toast.error("Vui lòng nhập đầy đủ thông tin địa chỉ!");
            return;
        };
        if (!phoneNumberRegex.test(_phone)) {
            toast.error("Vui lòng nhập số điện thoại đúng định dạng!");
            return;
        };
        let address = {
            address: _address,
            created: date_raw,
            updated: date_raw,
            current: true,
            province: province,
            district: district,
            ward: ward,
            location: location,
            name: _name,
            phone: _phone,
            type_address: _location
        }
        updateAddress(address, window.localStorage.getItem('key')).then((response) => {
            if (response["status"] === 200) {
                getAddress(window.localStorage.getItem('key')).then((response) => {
                    setAddress(response['message']);
                    const currentAddress = response['message'].find(item => item.current === true);
                    setLat(currentAddress.location?.latitude);
                    setLong(currentAddress.location?.longitude);
                    setCodeWard(currentAddress.ward?.code);
                    setDistrict(currentAddress.district?.code);
                    setProvince(currentAddress.province?.code);
                    getDataStore(currentAddress.location?.latitude, currentAddress.location?.longitude, '', '', '');
                    let addCart = {
                        address: currentAddress._id
                    };
                    updateAddressCart(addCart, window.localStorage.getItem('key')).then((reponse) => {
                        valid(2);
                        setUpdateShipping(false);
                        setIsPickAtStore(false);
                        loadDelivery();
                    });
                })
                cartInfo();
                props.parentCallback();
            } else {
                toast.error(response["message"]);
                return;
            }
        });

        //getDataStore(lat, long, '', '', '');
    }

    const [modalDeleteIsOpen, setModalDeleteIsOpen] = useState(false);
    //const [modalDeleteSuccessIsOpen, setModalDeleteSuccessIsOpen] = useState(false);
    const [itemDelete, setItemDelete] = useState('');
    const [skuItemDelete, setSkuItemDelete] = useState('');
    const openModalDelete = (sku, item) => {
        setModalDeleteIsOpen(true);
        setItemDelete(item);
        setSkuItemDelete(sku);
    };

    const closeModalDelete = () => {
        setModalDeleteIsOpen(false);
    };

    // const closeModalDeleteSuccess = () => {
    //     setModalDeleteSuccessIsOpen(false);
    // };

    const [modalPickTimeIsOpen, setModalPickTimeIsOpen] = useState(false);

    const handleRedirect = (uri) => {
        window.location.href = uri;
    }

    const handleClickDetail = (id) => {
        window.localStorage.setItem('tabCart', 'delivery');
        window.location.href = '/mobile/address-detail.html?' + id;
    }
    const handleLocalStorage = () => {
        loadAddress();
        loadDelivery();
        valid(1);
        cartInfo();
    };
    useEffect(() => {
        defaultAddressCart(null, window.localStorage.getItem('key'));
        loadAddress();
        cartInfo();
        returnHoursShipping();
        setDay(0);
        setActiveSelectDate(0);
        setActiveSelectDateText('Hôm nay');
        if (window.localStorage.getItem('tabCart') !== null) {
            if (window.localStorage.getItem('tabCart') === 'delivery') {
                handleLocalStorage();
            }
            setTab(window.localStorage.getItem('tabCart'));
            window.localStorage.removeItem('tabCart');
        }
    }, []);
    const chunkArray = (arr, size) => {
        return arr.reduce((chunks, el, i) => {
            if (i % size === 0) {
                chunks.push([el]);
            } else {
                chunks[chunks.length - 1].push(el);
            }
            return chunks;
        }, []);
    }
    const handlePickGiftDefault = (itemGift) => {
        window.localStorage.setItem("promo_code", itemGift.promo_code);
        window.localStorage.setItem("promo_type", itemGift.typectkm);
        window.location.href = '/mobile/chi-tiet-mua-hang-tang-qua/danh-sach-qua.html';
    }
    const [store, setStore] = useState([]);
    return (
        <>
            {
                (() => {
                    switch (tab) {
                        case 'cart':
                            return <>
                                <div id="cart-css">
                                    <div>
                                        {modalDeleteIsOpen && (
                                            <div className="modal">
                                                <div className="modal-content">
                                                    <div className="modal-body p-0">
                                                        <div className="text-center">
                                                            <span className="text-16-700">Xác nhận</span>
                                                        </div>
                                                        <div className="text-center mgy-20">
                                                            <span className="text-normal-13">Bạn có chắc chắn muốn xoá sản phẩm này<br></br> khỏi giỏ hàng không?</span>
                                                        </div>
                                                        <div className="text-center">
                                                            <button onClick={() => handleDelete()} className="btn-confirm pdy-10">
                                                                XÓA SẢN PHẨM
                                                            </button>
                                                        </div>
                                                        <div className="text-center mgt-10">
                                                            <button onClick={() => closeModalDelete()} className="btn-cancel pdy-10">
                                                                KHÔNG XÓA
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="fixed bg-index">
                                        <div className="row bg-white mgx-0">
                                            <div className="row header pdx-10 pdy-10 mgx-0">
                                                <div className="col-3 pdl-20" onClick={() => handleBack()}>
                                                    <i className="fa-solid fa fa-chevron-left"></i>
                                                </div>
                                                <div className="col-6 text-center">
                                                    <span className="name-page">GIỎ HÀNG</span>
                                                </div>
                                            </div>
                                            <div className="row pdy-10 pdx-20 mgx-0">
                                                <div className="col-6 text-center">
                                                    <span className="text-normal-13-bland fw-bold text-selected">Tất cả</span>
                                                </div>
                                                <div onClick={() => navigate('/mobile/wishlist.html')} className="col-6 text-center">
                                                    <span className="text-normal-13-bland fw-bold">Yêu thích</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row mgt-10">
                                            <div className="pdx-0">
                                                <div className="pdx-10 pdy-12 bg-white">
                                                    <ul className="bs4-order-tracking-mobile ">
                                                        <li id="cart" className="step active"> <div><div className="in-f hei-wid-100"><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/gio_hang_red.png" alt="icon" /></div></div><span className="text-normal-12">Giỏ hàng</span></li>
                                                        <li id="delivery" className="step"> <div><div className="in-f hei-wid-100"><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/giao_hang_none.png" alt="icon" /></div></div><span className="text-normal-12">Giao hàng</span></li>
                                                        <li id="payment" className="step "> <div><div className="in-f hei-wid-100"><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/thanh_toan_none.png" alt="icon" /></div></div><span className="text-normal-12"> Thanh toán </span></li>
                                                        <li id="complate" className="step "> <div><div className="in-f hei-wid-100"><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/thanh_cong_none.png" alt="icon" /></div></div><span className="text-normal-12"> Thành công </span> </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ height: 168 }}></div>
                                    {/* <div className="row mgt-10">
                                    <div>
                                        <div className="row mgx-10 pdx-24 pdy-10 card-yellow text-center">
                                            <span className="text-bold-14">Ưu đãi đơn hàng 2 triệu</span><br></br>
                                            <span className="text-normal-13">Mua thêm 275.000đ để nhận</span><br></br>
                                            <span className="text-normal-13"><span className="text-red-underline">Quà tặng trị giá 10%</span> giá trị đơn
                                                hàng</span>
                                        </div>
                                    </div>
                                </div> */}

                                    <div className="row mt-2">
                                        <div className="col-12 pdx-0 item-product">
                                            <ul>
                                                {
                                                    props.item_gifts.map((itemData) => (
                                                        <>
                                                            {itemData.nonGift.length > 0 ? (
                                                                itemData.nonGift.map((item, i) => (
                                                                    itemData.nonGift.findIndex(Item => Item.sku === item.sku) === i ? (
                                                                        <li key={i} className={itemData.nonGift.find(Item => Item.promo_code !== '' && i>0) ? ("bg-white mgt-10 pdy-20 pdx-5 li-item-product mt-0"):("bg-white mgt-10 pdy-20 pdx-5 li-item-product") }>
                                                                            <input hidden ref={skuRef} name="sku" defaultValue={item.sku} />
                                                                            <div onClick={() => handleRedirect('/' + item.linksp?.replace('/', ''))} className="col-4 img-item in-f"><img src={item.image} alt={item.name} />
                                                                            </div>
                                                                            <div className="col-8 d-grid pdr-20">
                                                                                <div className="d-flex justify-content-between">
                                                                                    <div className="pdr-10" onClick={() => handleRedirect('/' + item.linksp?.replace('/', ''))}>
                                                                                        <span className="text-normal-13"> {item.name}
                                                                                            {/* {item.name.length > 30 ? `${item.name.slice(0, 30)}...` : item.name} */}
                                                                                        </span><br />
                                                                                    </div>
                                                                                    <div className="text-13-red" onClick={() => openModalDelete(item.sku, item)}>
                                                                                        <i className="fa fa-trash-can"></i>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="list-attribute d-flex mgt-5">
                                                                                    {
                                                                                        item.size && item.size !== null ? (
                                                                                            <div className="item-attr mgr-10 d-flex align-items-center justify-content-center">
                                                                                                {item.size}
                                                                                            </div>
                                                                                        ) : (null)
                                                                                    }
                                                                                    {
                                                                                        item.color && item.color !== null && item.color !== '' ? (
                                                                                            <div className="item-ifo-color">
                                                                                                <div className="color-box">
                                                                                                    <div className="box-color-item" style={{ backgroundColor: item.color }}>
                                                                                                        {
                                                                                                            item?.color.includes('#') === false ? (item?.color) : (null)
                                                                                                        }
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        ) : (null)
                                                                                    }
                                                                                </div>
                                                                                <div className="d-flex justify-content-between align-items-center">
                                                                                    <div className="d-block">
                                                                                        {
                                                                                            item.price_old != item.price ? (<span className="price-sale">{FromatNumberVIE(item.price_old)}đ</span>) : (null)
                                                                                        }
                                                                                        <div className="d-flex">
                                                                                            <span className="price-now-cart">{FromatNumberVIE(item.price)}đ</span>
                                                                                            {
                                                                                                item.price_old != item.price ? (<span className="price-percent-cart text-center">-{((item.saving_money / item.price_old) * 100).toFixed(0)}%</span>) : (null)
                                                                                            }
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="group-btn-cong-tru d-flex">
                                                                                        <div className="btn-cong-tru" onClick={item.quantity > 1 ? () => handleUpdate(item.sku, item, +item.quantity - 1) : null}><i className="fa fa-minus"></i></div>
                                                                                        <input ref={quantityRef} className="input-quantity" type="number" min={1} id={'quantity_' + item.sku} name={'quantity_' + item.sku} readOnly value={item.quantity} />
                                                                                        <div className="btn-cong-tru" onClick={showButtonContinue ? () => handleUpdate(item.sku, item, +item.quantity + 1) : null}  ><i className="fa fa-plus"></i></div>
                                                                                    </div>
                                                                                </div>

                                                                                {
                                                                                    item.type === 'hotdeal' ? (
                                                                                        <div className="row mgt-10 mgx-0">
                                                                                            <button className="btn-type-product">
                                                                                                Hot Deal
                                                                                            </button>
                                                                                        </div>
                                                                                    ) : (null)
                                                                                }
                                                                                {
                                                                                    item.bixu > 0 ? (
                                                                                        <div className="row mgt-10 mgx-0">
                                                                                            <button className="btn-type-product-yellow">
                                                                                                Tích lũy thêm {FromatNumberVIE(item.bixu)} Bixu
                                                                                            </button>
                                                                                        </div>
                                                                                    ) : (null)
                                                                                }
                                                                                <div className="cart-nav-number">
                                                                                    <span className="text-13-red-400">{item.msg}</span>
                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                    ) : (
                                                                        null
                                                                    )
                                                                ))
                                                            ) : (null)}
                                                            {itemData.gift.length > 0 ? (
                                                                <div className="row bg-white slide-gift slide-gift-list mr-2">
                                                                    <Carousel key=""
                                                                        responsive={ResponsiveSliderTop}
                                                                        showDots={itemData.gift.length / 3 > 1}
                                                                        autoPlay={itemData.gift.length / 3 > 1}
                                                                        autoPlaySpeed={3000}
                                                                        infinite={true}
                                                                    >
                                                                        {chunkArray(itemData.gift, 3).map((group, groupIndex) => (
                                                                            <div key={groupIndex} className="">
                                                                                <div className="row mx-2">
                                                                                    {group.map((gift, index) => {
                                                                                        return <>
                                                                                            <div id="box-gift"  key={gift.id} className="col-6 pdx-5 pdy-5">
                                                                                                <div className="row mgx-0 img-item box-img in-f">
                                                                                                    <div className="col-12 mgt-5 item-box-gift">
                                                                                                        <div className="box-text-gift">
                                                                                                            <span>Tặng</span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="col-12 mgt-10">
                                                                                                        <img className="size-img-gift" src={gift.image.replace('/fullhd', '/thumb')} alt="icon" />
                                                                                                    </div>
                                                                                                    <input hidden defaultValue={gift.price} />
                                                                                                    <div className="col-12 in-f ">
                                                                                                        <div className="number-minus-gift in-f" onClick={() => handleUpdate(gift.sku, gift, +gift.quantity - 1)}>
                                                                                                            <i className="fa fa-minus fa-xs"></i>
                                                                                                        </div>
                                                                                                        <div className="pdx-10">
                                                                                                            <input ref={quantityRef} className="input-quantity" type="number" min={0} id={'quantity_' + gift.sku} name={'quantity_' + gift.sku} readOnly value={gift.quantity} />
                                                                                                        </div>
                                                                                                        <div className="number-plus-gift in-f" onClick={showButtonContinue ? () => handleUpdate(gift.sku, gift, +gift.quantity + 1) : null}>
                                                                                                            <i className="fa fa-plus fa-xs"></i>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="cart-nav-number">
                                                                                                        <span className="text-10-red-400">{gift.msg}</span>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </>
                                                                                    })}
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </Carousel>
                                                                    {/* <div className="col-12 in-f">
                                                                        <a className="text-gift-all" onClick={() => handlePickGiftDefault(itemData.gift[0])}>Chọn quà khác &gt;&gt;&gt;</a>
                                                                    </div> */}
                                                                </div>) : (null)
                                                            }
                                                           {
                                                                itemData.nonGift.length > 0 ? (
                                                                    itemData.nonGift.find(Item => Item.promo_code !== '') ? (
                                                                        <div className="row mgx-0 pdl-6 bg-white slide-gift slide-gift-list">
                                                                            <div className="col-12 in-f">
                                                                                <a className="text-gift-all" onClick={() => handlePickGiftDefault(itemData.nonGift[0])}>Chọn quà khác &gt;&gt;&gt;</a>
                                                                            </div>
                                                                        </div>
                                                                    ):(null)
                                                                ):(null)
                                                            }
                                                        </>
                                                    )
                                                    )
                                                }

                                            </ul>
                                            <div style={{height:20}} className="bg-white"></div>
                                        </div>
                                    </div>

                                    {/* <div className="row pdx-24 pdt-20 bg-white">
                                        <div className="col-12 gift-bixu in-f">
                                            <span>Ba Mẹ hiện có <span className="color-detail-bixu"> {window.localStorage.getItem('bixu') && window.localStorage.getItem('bixu') !== null && window.localStorage.getItem('bixu') !== 'undefined' ? FromatNumberVIE(window.localStorage.getItem('bixu')) : 0} Bixu</span> để đổi quà</span>
                                        </div>
                                        <div className="col-12 mgy-20 in-f">
                                            <div className="box-gift">
                                                <div className="col-12 bow-tie">
                                                    <img src="/../images/product/bow_tie.png" alt="icon" />
                                                </div>
                                                <div className="col-12 text-gift-now">
                                                    <span>ĐỔI QUÀ NGAY</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                                    <div className='height-w bg-white'></div>
                                    <div className="row total-payment pdy-10 mgx-0 pdx-20" id="fixed-footer">
                                        <div className="d-flex justify-content-between pdx-0">
                                            <div>
                                                <span className="text-normal-12">Tạm tính:</span><br></br>
                                                <span className="total-price">{FromatNumberVIE(cartInfoItems[0]?.amount)}đ</span>
                                            </div>
                                            <div className="float-right">
                                                <span className="text-normal-12">Khuyến mại: <span className="price-discount"> {FromatNumberVIE(calculateSum(props.items, 'saving_money'))} đ</span></span><br></br>
                                                <span className="text-normal-12">Tích lũy: <span className="total-bixu"> {FromatNumberVIE(cartInfoItems[0]?.bixu?.refund)} Xu</span></span>
                                            </div>
                                        </div>
                                        <div className="mgt-5 pdx-0">
                                            {
                                                showButtonContinue ? (
                                                    <button className="btn-next" onClick={() => handleContinues()}>
                                                        TIẾP TỤC
                                                    </button>
                                                ) : (
                                                    <button className="btn-next-grey">
                                                        TIẾP TỤC
                                                    </button>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </>;
                        case 'delivery':
                            return <>
                                <div id="cart-css">
                                    <div className="fixed bg-index">
                                        <div className="row bg-white mgx-0">
                                            <div className="row header pdx-10 pdy-10 mgx-0">
                                                <div className="col-3 pdl-20" onClick={() => handleBack()}>
                                                    <i className="fa-solid fa fa-chevron-left"></i>
                                                </div>
                                                <div className="col-6 text-center">
                                                    <span className="name-page">GIAO HÀNG</span>
                                                </div>
                                                {/* <div className="col-4 header-right">
                                                <img src="/../images/product/Search.png" />
                                            </div> */}
                                            </div>
                                        </div>
                                        <div className="row mgt-10 mgx-0">
                                            <div className="pdx-0">
                                                <div className="pdx-10 pdy-12 bg-white">
                                                    <ul className="bs4-order-tracking-mobile ">
                                                        <li id="cart" className="step active"> <div><div className="in-f hei-wid-100"><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/gio_hang_red.png" alt="icon" /></div></div><span className="text-normal-12">Giỏ hàng</span></li>
                                                        <li id="delivery" className="step active"><div><div className="in-f hei-wid-100"><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/giao_hang_red.png" alt="icon" /></div></div><span className="text-normal-12">Giao hàng</span></li>
                                                        <li id="payment" className="step "> <div><div className="in-f hei-wid-100"><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/thanh_toan_none.png" alt="icon" /></div></div><span className="text-normal-12"> Thanh toán </span></li>
                                                        <li id="complate" className="step "> <div><div className="in-f hei-wid-100"><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/thanh_cong_none.png" alt="icon" /></div></div><span className="text-normal-12"> Thành công </span> </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ height: 128 }}></div>
                                    <div className="bg-white">
                                        <div className="row text-normal-12-700 pdy-10 mgx-20 border-b">
                                            <span>CHỌN HÌNH THỨC GIAO HÀNG</span>
                                        </div>

                                        <div className="row mgt-10 pdx-10 mgx-0">
                                            <div className="row pdy-5 bg-yellow text-center mgx-0">
                                                <span className="text-normal-13">Bạn có thể chọn hình thức giao hàng theo tiêu chí</span><br />
                                                <span className="text-bold-13">Giao nhanh nhất - Phí giao rẻ nhất - Nhiều ưu đãi nhất</span>
                                            </div>
                                        </div>

                                        <div className="cart-delivery-method">
                                            <div>
                                                <ul className="list-delivery-method-mobile pdx-20 m-0">
                                                    <li>
                                                        <div className="row detail-delivery-method pdy-10 pdx-10 mgt-10 mgx-0">
                                                            <div className="col-1 pdx-0">
                                                                <input defaultChecked={isPickAtStore} className="form-check-input mgy-0" type="radio" name="shipping" id="location" onClick={() => handleShowPopup()} />
                                                            </div>
                                                            <div className="col-7 p-0 delivery-content">
                                                                <span className="text-normal-13">Nhận hàng tại Cửa hàng</span><br></br>
                                                                <span className="delivery-time">Nhận hàng trong 24h</span>
                                                            </div>
                                                            {/* <div className="col-4 delivery-num">
                                                            <span className="text-yellow">Tặng 5.000 Bixu</span>
                                                        </div> */}
                                                        </div>
                                                    </li>
                                                    {showPopup && (
                                                        <>
                                                            {/* <li className="p-0">
                                                            <div className="card-yellow mgt-10 d-flex pdx-10 pdy-10">
                                                                <div className="d-flex align-items-center mgr-10">
                                                                    <img src="/../images/cart/Group 7642902.png" alt="" />
                                                                </div>
                                                                <div>
                                                                    <span className="text-normal-13">
                                                                        Tặng 5000 Bixu ~ 5.000đ cho các đơn hàng đặt hàng qua App/Web và nhận hàng tại Cửa
                                                                        hàng
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </li> */}
                                                            <li className="p-0 d-block">
                                                                {
                                                                    (ItemsStoreSelected != null) ?
                                                                        (
                                                                            <div className="bg-yellow-bottom mgt-10 pdx-12 pdy-10 d-block">
                                                                                <div className="d-flex justify-content-between">
                                                                                    <span className="text-normal-12-700">{ItemsStoreSelected.store.name}</span>
                                                                                </div>
                                                                                <div className="d-flex pdt-5">
                                                                                    <div className="d-flex align-items-center mgr-10">
                                                                                        <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/location.png" alt="icon" />
                                                                                    </div>
                                                                                    <div className="d-flex">
                                                                                        <span className="text-normal-13 line-height-18">{ItemsStoreSelected.store?.address}</span>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="d-flex justify-content-between mgt-5">
                                                                                    <div>
                                                                                        <img className="mgr-10" src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/call.png" alt="icon" />
                                                                                        <span className="text-13-red">024 7309 1168</span>
                                                                                    </div>
                                                                                    <div className="link-google">
                                                                                        <a href={'https://www.google.com/maps/dir/?api=1&destination=' + ItemsStoreSelected.store?.location?.latitude + ',' + ItemsStoreSelected.store?.location?.longitude + '&travelmode=driving'} target="_blank">
                                                                                            <img className="mgr-10" src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/people.png" alt="icon" />
                                                                                            <span className="text-13-red">Chỉ đường</span>
                                                                                        </a>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                        ) : (
                                                                            null
                                                                        )
                                                                }


                                                            </li>
                                                            {
                                                                (isPickAtStore === true) ?
                                                                    (
                                                                        <>
                                                                            <div className="mgt-10">
                                                                                <button className="btn-next" onClick={() => handleShowSelectedStore()}>
                                                                                    CỬA HÀNG GẦN BẠN
                                                                                </button>
                                                                            </div>
                                                                            <div className="col-12  text-normal-13 in-f mgt-10">
                                                                                {
                                                                                    (dataItemsStore.filter(store => store.store?.satisfyCart === 1)).length > 0 ? (
                                                                                        <span> {(dataItemsStore.filter(store => store.store?.satisfyCart === 1)).length} cửa hàng hiện đang có sản phẩm này</span>
                                                                                    ) : (
                                                                                        <span> Chưa có thông tin cửa hàng.</span>
                                                                                    )
                                                                                }
                                                                            </div>
                                                                            {/* <div className="card-yellow mgt-10 pdx-10 pdy-10 d-block">
                                                                                <span className="text-bold-14">Lưu ý</span><br></br>
                                                                                <span className="text-normal-13">
                                                                                    Sản phẩm ở Cửa hàng có thể bán hết trước khi Bạn đến. Vui lòng xác nhận đặt trước để giữ
                                                                                    hàng 24h.
                                                                                </span>
                                                                            </div> */}
                                                                            <li>
                                                                                <div className="col-12 mgt-10 mgb-5 in-f">
                                                                                    <div className="col-11 delivery-num"><span className="text-normal-13 mgr-10">Giữ hàng cho tôi, tôi sẽ đến trong 24h tới</span></div>
                                                                                    <div className="col-1 in-f"><input className="form-check-input mgy-0" type="radio" defaultChecked /></div>
                                                                                </div>
                                                                            </li>
                                                                        </>

                                                                    ) : (null)
                                                            }

                                                        </>
                                                    )}
                                                    {
                                                        itemsDelevery?.length > 0 ?
                                                            (
                                                                itemsDelevery.map((item, i) => (
                                                                    <li key={i}>
                                                                        <div className="row detail-delivery-method pdy-10 pdx-10 mgt-10 mgx-0">
                                                                            <div className="col-1 pdx-0">
                                                                                <input
                                                                                    className="form-check-input mgy-0"
                                                                                    id={item.code}
                                                                                    type="radio"
                                                                                    name="shipping"
                                                                                    readOnly
                                                                                    defaultChecked={firstItemDelivery === item.code ? true : false}
                                                                                    onClick={item.code == '30P' ? (() => handleDeliveryFat(item.code)) : (() => handleClick(item.code))}
                                                                                />
                                                                            </div>
                                                                            <div className="col-7 p-0 delivery-content">
                                                                                <span className="text-normal-13">{item.title}</span><br></br>
                                                                                <span className="delivery-time">{item.description}</span>
                                                                            </div>
                                                                            <div className="col-4 delivery-num">
                                                                                <span className="text-13-red-400">{FromatNumberVIE(item.fees)}đ</span>
                                                                            </div>
                                                                        </div>
                                                                        {/* {
                                                                        item.code === 'PHS' ? (
                                                                            <>
                                                                                <div className="card-yellow mgt-10 d-flex pdx-10 pdy-10">
                                                                                    <div className="d-flex align-items-center mgr-10">
                                                                                        <img src="/../images/cart/bikes.png" alt="" />
                                                                                    </div>
                                                                                    <div>
                                                                                        <span className="text-normal-13">
                                                                                            Theo lịch giao hàng của đối tác.
                                                                                            Nếu Bạn có yêu cầu thời gian giao cụ thể, vui lòng “Chọn thời gian nhận hàng"
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            null
                                                                        )
                                                                    } */}
                                                                        {
                                                                            item.code === '30P' && isDeliveryFat ? (
                                                                                <>
                                                                                    <div className="bg-yellow-bottom mgt-10 d-flex pdx-12 pdy-10">
                                                                                        <div className="d-flex align-items-center mgr-10">
                                                                                            <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/giao_hoa_toc.png" alt="icon" />
                                                                                        </div>
                                                                                        <div className="d-flex">
                                                                                            <span className="text-normal-13 line-hei-15">
                                                                                                Các đơn hàng nội thành mặc định giao trong vòng 15-60 phút. Nếu Bạn không thể nhận
                                                                                                hàng trong vòng 60 phút, vui lòng chọn giờ khác.
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="row detail-delivery-method">
                                                                                        <div className="col-12 mgt-10 mgb-5 in-f">
                                                                                            <div className="col-11 delivery-num"><span className="text-normal-13 mgr-10">Chọn thời gian nhận hàng</span></div>
                                                                                            <div className="col-1 in-f"><input className="form-check-input mgy-0" type="radio" onClick={() => setModalPickTimeIsOpen(true)} /></div>
                                                                                        </div>
                                                                                    </div>
                                                                                    {
                                                                                        timeSelected != '' ? (
                                                                                            <>
                                                                                                <div className="row detail-delivery-method pdx-24">
                                                                                                    <div className="d-flex justify-content-between">
                                                                                                        <div>
                                                                                                            <span className="text-bold-13-green">Hôm nay</span>
                                                                                                        </div>
                                                                                                        <div>
                                                                                                            <span className="text-bold-13-green">{timeSelectedText}</span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </>
                                                                                        ) : (null)
                                                                                    }
                                                                                    {
                                                                                        modalPickTimeIsOpen && (
                                                                                            <div className="modal" >
                                                                                                <div className="modal-content">
                                                                                                    <div className="modal-body p-0">
                                                                                                        <div className="d-flex justify-content-between">
                                                                                                            <span className="text-bold-14">CHỌN KHUNG GIỜ GIAO HÀNG</span>
                                                                                                            <i onClick={() => setModalPickTimeIsOpen(false)} className="fas fa-times"></i>
                                                                                                        </div>
                                                                                                        <div className="row mgy-20">
                                                                                                            <div className="d-flex p-0">
                                                                                                                <div className="popup-select-day pdx-10">
                                                                                                                    <ul className="select-day pdx-0" id="select-day">
                                                                                                                        <li key="select-day" className={activeSelectDate === 0 ? ('select') : (null)} onClick={() => handleDay(0, 'Hôm nay')}>Hôm nay</li>
                                                                                                                    </ul>
                                                                                                                </div>
                                                                                                                <div className="popup-select-house">
                                                                                                                    <ul className="select-time">
                                                                                                                        {
                                                                                                                            hours.map((item, i) => {
                                                                                                                                return <li key={i} className={activeSelectTime === item ? ('select') : (null)}
                                                                                                                                    onClick={() => handleTime(item, item + ':00 - ' + (item + 1) + ':00')}>{item}:00 - {item + 1}:00</li>
                                                                                                                            })
                                                                                                                        }
                                                                                                                    </ul>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div className="text-center mgt-10" onClick={() => handleSaveTime()}>
                                                                                                            <button className="btn-cancel pdy-10" >
                                                                                                                XÁC NHẬN
                                                                                                            </button>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        )
                                                                                    }

                                                                                </>
                                                                            ) : (
                                                                                null
                                                                            )
                                                                        }
                                                                    </li>

                                                                ))
                                                            ) : (null)
                                                    }
                                                    {
                                                        isPickAtStore === false ? (
                                                            <>
                                                                <li>
                                                                    <div className="row detail-delivery-method mgx-0 pd-10">
                                                                        <div className="col-11">
                                                                            <span className="text-normal-12-700">ĐỊA CHỈ GIAO HÀNG</span>
                                                                        </div>
                                                                        {/* <div className="col-1">
                                                                            <a><i className="fa fa-pen-to-square fa-lx" onClick={() => handleUpdateShipping()}></i></a>
                                                                        </div> */}
                                                                    </div>
                                                                </li>
                                                                {
                                                                    isUpdateShipping == true ? (
                                                                        <>
                                                                            <form className="needs-validation pdx-10" noValidate onSubmit={handleAddAddress}>
                                                                                <div className="cart-delivery-title pdx-20">
                                                                                    <span className="text-bold-13">
                                                                                        Vui lòng cập nhật thông tin bên dưới để tiếp tục mua hàng
                                                                                    </span>
                                                                                </div>

                                                                                <div className="col-12 m-body">
                                                                                    <div className="col-12">
                                                                                        <span className="require-start text-bold-13">Họ và tên</span>
                                                                                    </div>
                                                                                    <div className="col-12">
                                                                                        <input required name="name" className="select-custom w-100" defaultValue={window.localStorage.getItem('name')} />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-12 m-body">
                                                                                    <div className="col-12">
                                                                                        <span className="require-start text-bold-13">Số điện thoại</span>
                                                                                    </div>
                                                                                    <div className="col-12">
                                                                                        <input required name="phone" className="select-custom w-100" defaultValue={window.localStorage.getItem('phone')} />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-12 m-body">
                                                                                    <div className="col-12">
                                                                                        <span className="require-start text-bold-13">Địa chỉ</span>
                                                                                    </div>
                                                                                    <div className="col-12">
                                                                                        <input ref={addressRef} className="select-custom w-100" name="address" required />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-12 m-body">
                                                                                    <div className="col-12">
                                                                                        <span className="require-start text-bold-13">Tỉnh/ Thành phố</span>
                                                                                    </div>
                                                                                    <div className="col-12">
                                                                                        <select className="select-custom w-100" required onChange={(e) => handleShowDisstrict(e)} name="province">
                                                                                            <option value="">Chọn Tỉnh/ Thành phố</option>
                                                                                            {
                                                                                                itemProvinces?.map((item, i) => {
                                                                                                    return <option key={i} value={item._id} data={JSON.stringify(item)}>{item.name}</option>
                                                                                                })
                                                                                            }
                                                                                        </select>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-12 m-body">
                                                                                    <div className="address-location">
                                                                                        <div className="m-location-detail">
                                                                                            <div className="col-12 c1 m1">
                                                                                                <span className="require-start text-bold-13">Quận, Huyện </span>
                                                                                                <select className="select-custom w-100" required onChange={(e) => handleShowWard2(e)} name="district">
                                                                                                    <option value="">Chọn Quận, Huyện</option>
                                                                                                    {
                                                                                                        itemDistrict?.map((item, i) => {
                                                                                                            return <option key={i} value={item._id} data={JSON.stringify(item)}>{item.name}</option>
                                                                                                        })
                                                                                                    }
                                                                                                </select>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="m-location-detail">
                                                                                            <div className="col-12 m1">
                                                                                                <span className="require-start text-bold-13">Phường, Xã</span>
                                                                                                <select className="select-custom w-100" required name="ward" onChange={(e) => handleChangeWard(e)}>
                                                                                                    <option value="">Chọn Phường, Xã</option>
                                                                                                    {
                                                                                                        itemWard?.map((item, i) => {
                                                                                                            return <option key={i} value={item._id} data={JSON.stringify(item)}>{item.name}</option>
                                                                                                        })
                                                                                                    }
                                                                                                </select>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-12 m-body">
                                                                                    <div className="col-12 d-flex">
                                                                                        <div className="col-6">
                                                                                            <div className="in-f">
                                                                                                <input className="form-check-input mgy-0 mgr-5" type="radio" name="rdio_location" defaultValue="1" />
                                                                                                <label className="form-check-label text-bold-13">Địa chỉ nhà</label>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="col-6">
                                                                                            <div className="in-f mgl-5">
                                                                                                <input className="form-check-input mgy-0 mgr-5" type="radio" name="rdio_location" defaultValue="2" />
                                                                                                <label className="form-check-label text-bold-13" >Địa chỉ cơ quan</label>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="col-12 m-body">
                                                                                    <button className="btn-next">LƯU ĐỊA CHỈ</button>
                                                                                </div>
                                                                            </form>
                                                                        </>
                                                                    ) : ('')
                                                                }

                                                                {
                                                                    cartInfoItems[0]?.shipping?.address != null ? (
                                                                        <>
                                                                            <li>
                                                                                <div className="row detail-delivery-method mgx-0 pd-10">
                                                                                    <div className="detail-address-text d-flex justify-content-between">
                                                                                        <div className="address-detail mgr-10" onClick={() => { handleClickDetail(cartInfoItems[0].shipping?.address._id) }}>
                                                                                            <div className="col-12"><span className="text-bold-13">{cartInfoItems[0].shipping?.address.name}</span></div>
                                                                                            <div className="col-12 d-flex"><span className="text-normal-13 line-hei-15">{cartInfoItems[0].shipping?.address.address + ', ' +
                                                                                                cartInfoItems[0].shipping?.address.ward?.name + ', ' +
                                                                                                cartInfoItems[0].shipping?.address.district?.name + ', ' +
                                                                                                cartInfoItems[0].shipping?.address.province?.name}</span></div>
                                                                                            <div className="col-12"><span className="text-normal-13">{cartInfoItems[0].shipping?.address.phone}</span></div>
                                                                                        </div>
                                                                                        <div id="content1" className="d-flex align-flex-start">
                                                                                            <details>
                                                                                                <summary className="bg-white">
                                                                                                    <table>
                                                                                                        <tr>
                                                                                                            <td><i className="fa-solid fa-ellipsis-vertical fa-lg pdl-5"></i></td>
                                                                                                            <td></td>
                                                                                                        </tr>
                                                                                                    </table>
                                                                                                </summary>
                                                                                                <div className="btn-open-update-address">
                                                                                                    <a onClick={() => { handleClickDetail(cartInfoItems[0].shipping?.address._id) }}><i title="Chỉnh sửa" className="fa fa-pen-to-square pdl-5"></i><p>Sửa</p></a>
                                                                                                    {/* <a><i title="Xóa" className="fa fa-trash-can" ></i><p>Xóa</p></a> */}
                                                                                                </div>
                                                                                            </details>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="d-flex justify-content-between mgt-10">
                                                                                        <div className="type-address m-0">
                                                                                            {cartInfoItems[0].shipping?.address.type_address == 2 ? (<span className="text-normal-13">Cơ quan</span>) : (<span className="text-normal-13">Địa chỉ nhà</span>)}
                                                                                        </div>
                                                                                        {
                                                                                            cartInfoItems[0].shipping?.address.current === true ? (
                                                                                                <>
                                                                                                    <div className="form-check-address">
                                                                                                        <input defaultChecked disabled className="form-check-input address-input" type="checkbox" value="true" />
                                                                                                        <label className="form-check-label text-normal-13" htmlFor="flexCheckDefault">Địa chỉ
                                                                                                            mặc định</label>
                                                                                                    </div>
                                                                                                </>
                                                                                            ) : (null)
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            </li>
                                                                            <li>
                                                                                <div className="row">
                                                                                    <div className="col-12 pdx-30 pdy-10">
                                                                                        <button className="btn-confirm pdy-10" onClick={() => handleChangeAdd()}>
                                                                                            ĐỊA CHỈ KHÁC
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            </li>
                                                                        </>
                                                                    ) : (null)
                                                                }
                                                            </>

                                                        ) : (
                                                            null
                                                        )
                                                    }



                                                    <li>
                                                        <div className="row detail-delivery-method mgx-10 pd-10">
                                                            <div className="col-12">
                                                                <span className="text-normal-12-700">GHI CHÚ ĐƠN HÀNG</span>
                                                            </div>
                                                        </div>
                                                        <div className="cart-textarea mgt-10">
                                                            <div>
                                                                <textarea ref={noteOrderRef} className="form-control" rows="3" name="note_cart"></textarea>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ height: 135 }}></div>
                                    <div className="row total-payment mgt-10 pdy-10 pdx-20 mgx-0" id="fixed-footer">
                                        <div className="row mgb-5 bg-white pdx-0 mgx-0">
                                            <div className="col-6 pdx-0">
                                                <div className="col-12 line-hei-15 mgb-5">
                                                    <span className="text-normal-12">Tạm tính:</span>
                                                </div>
                                                <div className="col-12 line-hei-15">
                                                    <span className="total-price">{FromatNumberVIE(cartInfoItems[0]?.total)}đ</span>
                                                </div>
                                            </div>
                                            <div className="col-6 float-right pdx-0">
                                                <div className="col-12 line-hei-15">
                                                    <span className="text-normal-12">Khuyến mại: <span className="price-discount"> {FromatNumberVIE(calculateSum(props.items, 'saving_money'))} đ</span></span>
                                                </div>
                                                <div className="col-12 line-hei-15">
                                                    <span className="text-normal-12">Tích lũy: <span className="total-bixu"> {FromatNumberVIE(cartInfoItems[0]?.bixu?.refund)} Xu</span></span>
                                                </div>
                                                <div className="col-12 line-hei-15">
                                                    {
                                                        isPickAtStore ? (<span className="text-normal-12">Phí vận chuyển: <span className="total-delivery"> 0 đ</span></span>) :
                                                            (
                                                                <span className="text-normal-12">Phí vận chuyển: <span className="total-delivery"> {FromatNumberVIE(cartInfoItems[0]?.shipping?.item?.fees)} đ</span></span>
                                                            )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mgt-5 pdx-0">
                                            {
                                                showButtonContinue && (ItemsStoreSelected !== null || codeShipping !== '')  && showButtonContinue ? (
                                                    <button className="btn-next" onClick={() => handleContinues()}>
                                                        TIẾP TỤC
                                                    </button>
                                                ) : (
                                                    <button className="btn-next-grey">
                                                        TIẾP TỤC
                                                    </button>
                                                )
                                            }

                                        </div>
                                    </div>
                                </div>
                            </>;
                        case 'list-delivery':
                            return <>
                                <div id="cart-css">
                                    <div className="fixed bg-index">
                                        <div className="row bg-white mgx-0">
                                            <div className="row header pdx-10 pdy-10 mgx-0">
                                                <div className="col-2 pdl-20" onClick={() => handleBack()}>
                                                    <i className="fa-solid fa fa-chevron-left"></i>
                                                </div>
                                                <div className="col-8 text-center">
                                                    <span className="name-page">CHỌN ĐỊA CHỈ NHẬN HÀNG</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ height: 43 }}></div>
                                    <ListDeliveryMobile
                                        back={handleBack}
                                        setLat={setLat}
                                        setLong={setLong}
                                    />
                                </div>
                            </>;
                        case 'store':
                            return <>
                                <div id="cart-css">
                                    <div className="fixed bg-index">
                                        <div className="row bg-white mgx-0">
                                            <div className="row header pdx-10 pdy-10 mgx-0">
                                                <div className="col-3 pdl-20" onClick={() => handleBack()}>
                                                    <i className="fa-solid fa fa-chevron-left"></i>
                                                </div>
                                                <div className="col-6 text-center">
                                                    <span className="name-page">CỬA HÀNG GẦN BẠN</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ height: 43 }}></div>

                                    <div className="row pdx-20 mgx-0">
                                        <div className="pdx-0">
                                            <div className="bg-yellow-bottom mgt-10 pdx-10 pdy-10 d-block">
                                                <div className="d-flex">
                                                    <div className="d-flex align-items-center mgr-10">
                                                        <img src="/../images/cart/gps.png" alt="icon" />
                                                    </div>
                                                    <div className="d-flex">
                                                        <span className="text-normal-13 line-height-15">
                                                            Hệ thống ưu tiên sử dụng vị trí hiện tại của Bạn để tìm Cửa hàng gần nhất có sản phẩm Bạn
                                                            yêu cầu
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="bg-yellow-bottom mgt-10 pdx-10 pdy-10 d-block">
                                                <div className="d-flex mgt-5">
                                                    <div className="d-flex align-items-center mgr-10">
                                                        <img src="/../images/cart/pen.png" alt="icon" />
                                                    </div>
                                                    <div className="d-flex">
                                                        <span className="text-normal-13 line-height-15">
                                                            Nếu địa điểm nhận hàng khác vị trí hiện tại, vui lòng cập nhật thông tin khu vực Cửa hàng
                                                            Bạn muốn tìm
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row mgt-10 pdx-20 mgx-0">
                                        <div className="pdx-0">
                                            <div className="col-12">
                                                <select className="select-custom w-100" name="province" required onChange={(e) => handleShowDisstrict(e)}>
                                                    <option value="">Chọn Tỉnh/Thành phố</option>
                                                    {
                                                        itemProvinces?.map((item, i) => {
                                                            return <option key={i} value={item._id} data={JSON.stringify(item)}>{item.name}</option>
                                                        })
                                                    }
                                                </select>
                                            </div>
                                            <div className="col-12 in-f mgt-5">
                                                <div className="col-6 pl-0 pdr-5">
                                                    <select className="select-custom w-100" required onChange={(e) => handleShowWard(e)} name="district">
                                                        <option value="">Chọn Quận, Huyện</option>
                                                        {
                                                            itemDistrict?.map((item, i) => {
                                                                return <option key={i} value={item._id} data={JSON.stringify(item)}>{item.name}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-6 pr-0 pdl-5">
                                                    <select className="select-custom w-100" required name="ward" onChange={(e) => handleGetstore(e)}>
                                                        <option value="">Chọn Phường, Xã</option>
                                                        {
                                                            itemWard?.map((item, i) => {
                                                                return <option key={i} value={item._id} data={item.code}>{item.name}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        isShowCH ? (
                                            <>
                                                <div className="row mgt-10 pdx-20 mgx-0">
                                                    <div className="pdx-0">
                                                        <div className="bg-white text-center pdy-10">
                                                            <span className="text-bold-14">Có {(dataItemsStore.filter(store => store.store?.satisfyCart === 1)).length} / {dataItemsStore.length} cửa hàng gần bạn có sản phẩm</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                {
                                                    dataItemsStore.length > 0 ? (
                                                        dataItemsStore.map((item, i) => {
                                                            return <>
                                                                {
                                                                    item.store.satisfyCart === 1 ? (
                                                                        <div className="row pdx-20 mgx-0">
                                                                            <div className="mgt-10 pdx-0">
                                                                                <div className="bg-white pdy-12 pdx-15">
                                                                                    <div className="d-flex justify-content-between">
                                                                                        <span className="text-bold-13">{item.store?.name}</span>
                                                                                        {
                                                                                            item.store?.satisfyCart === 1 ? (
                                                                                                <input className="form-check-input" type="radio" name="checkboxCH" id={item.store.code} onClick={() => handleGetCodeWWard(item.store?.code, item)} />

                                                                                            ) : (
                                                                                                <div>
                                                                                                    <span className="text-yellow">Hết hàng</span>
                                                                                                </div>
                                                                                            )
                                                                                        }
                                                                                    </div>
                                                                                    <div className="d-flex mgt-5">
                                                                                        <div className="d-flex align-items-center mgr-10">
                                                                                            <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/location.png" alt="icon" />
                                                                                        </div>
                                                                                        <div className="d-flex">
                                                                                            <span className="text-normal-13 line-hei-15">
                                                                                                {item.store?.address}
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="d-flex mgt-5">
                                                                                        <div className="d-flex align-items-center mgr-10">
                                                                                            <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/clock.png" alt="icon" />
                                                                                        </div>
                                                                                        <div>
                                                                                            <span className="text-normal-13">
                                                                                                {item.store?.working?.open}:00 - {item.store?.working?.close}:00
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="d-flex justify-content-between mgt-5">
                                                                                        <div>
                                                                                            <img className="mgr-10" src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/call.png" alt="icon" />
                                                                                            <span className="text-13-red">024 7309 1168</span>
                                                                                        </div>
                                                                                        {/* <div>
                                                                                <i className="fa fa-person-walking text-danger mgr-5"></i>
                                                                                <span className="text-13-red">  {Rounding(item.distance ?? 0, 1)} km</span>
                                                                            </div> */}
                                                                                        <div className="link-google">
                                                                                            <a href={'https://www.google.com/maps/dir/?api=1&destination=' + item.store?.location?.latitude + ',' + item.store?.location?.longitude + '&travelmode=driving'} target="_blank">
                                                                                                <img className="mgr-10" src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/people.png" alt="icon" />
                                                                                                <span className="text-13-red">Chỉ đường</span>
                                                                                            </a>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        null
                                                                    )
                                                                }
                                                            </>
                                                        })
                                                    ) : (null)
                                                }
                                                <div style={{ height: 72 }}></div>
                                                {
                                                    ItemsStoreSelected  && showButtonContinue ? (
                                                        <div className="mgt-10 mgx-0 pdx-24 pdy-12 bg-index" id="fixed-footer">
                                                            <button className="btn-next" onClick={() => handleUpdateStore()}>
                                                                TIẾP TỤC
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <div className="mgt-10 mgx-0 pdx-24 pdy-12 bg-index" id="fixed-footer">
                                                            <button className="btn-next-grey">
                                                                TIẾP TỤC
                                                            </button>
                                                        </div>
                                                    )
                                                }

                                            </>
                                        ) : (null)}
                                </div>
                            </>;
                        case 'payment':
                            return <>
                                <div id="cart-css">
                                    <div className="fixed bg-index">
                                        <div className="row bg-white mgx-0">
                                            <div className="row header pdx-10 pdy-10 mgx-0">
                                                <div className="col-3 pdl-20" onClick={() => handleBack()}>
                                                    <i className="fa-solid fa fa-chevron-left"></i>
                                                </div>
                                                <div className="col-6 text-center">
                                                    <span className="name-page">THANH TOÁN</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mgt-10 mgx-0">
                                            <div className="pdx-0">
                                                <div className="pdx-10 pdy-12 bg-white">
                                                    <ul className="bs4-order-tracking-mobile ">
                                                        <li id="cart" className="step active"> <div><div className="in-f hei-wid-100"><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/gio_hang_red.png" alt="icon" /></div></div><span className="text-normal-12">Giỏ hàng</span></li>
                                                        <li id="delivery" className="step active"><div><div className="in-f hei-wid-100"><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/giao_hang_red.png" alt="icon" /></div></div><span className="text-normal-12">Giao hàng</span></li>
                                                        <li id="payment" className="step active"> <div><div className="in-f hei-wid-100"><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/thanh_toan_red.png" alt="icon" /></div></div><span className="text-normal-12"> Thanh toán </span></li>
                                                        <li id="complate" className="step "> <div><div className="in-f hei-wid-100"><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/thanh_cong_none.png" alt="icon" /></div></div><span className="text-normal-12"> Thành công </span> </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ height: 128 }}></div>

                                    <PaymentMobile key="payment" parentCallback={callbackFunction} />

                                    <div style={{ height: 0 }}></div>
                                    <div className="row total-payment mgt-10 pdy-10 pdx-20 mgx-0" id="fixed-footer">
                                        <div className="row mgb-5 bg-white mgx-0 pdx-0">
                                            <div className="col-6 pdx-0">
                                                <div className="col-12 line-hei-15 mgb-5">
                                                    <span className="text-normal-12">Tạm tính:</span>
                                                </div>
                                                <div className="col-12 line-hei-15">
                                                    <span className="total-price">{FromatNumberVIE(cartInfoItems[0]?.total)}đ</span>
                                                </div>
                                            </div>
                                            <div className="col-6 float-right pdx-0">
                                                <div className="col-12 line-hei-15">
                                                    <span className="text-normal-12">Khuyến mại: <span className="price-discount"> {FromatNumberVIE(calculateSum(props.items, 'saving_money'))}</span></span>
                                                </div>
                                                <div className="col-12 line-hei-15">
                                                    <span className="text-normal-12">Tích lũy: <span className="total-bixu"> {FromatNumberVIE(cartInfoItems[0]?.bixu?.refund)} Xu</span></span>
                                                </div>
                                                <div className="col-12 line-hei-15">
                                                    {
                                                        cartInfoItems[0]?.shipping?.item?.fees ? (
                                                            <span className="text-normal-12">Phí vận chuyển: <span className="total-delivery"> {FromatNumberVIE(cartInfoItems[0]?.shipping?.item?.fees)}đ</span></span>
                                                        ) : (<span className="text-normal-12">Phí vận chuyển: <span className="total-delivery"> 0đ</span></span>)

                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mgt-5 pdx-0">
                                            {
                                                isCheckPayment && showButtonContinue ? (
                                                    <button className="btn-next" onClick={() => handleContinues()}>
                                                        TIẾP TỤC
                                                    </button>
                                                ) : (
                                                    <button className="btn-next-grey">
                                                        TIẾP TỤC
                                                    </button>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </>;
                        case 'complete':
                            return <>
                                <div id="cart-css">
                                    <div className="fixed bg-index">
                                        <div className="row bg-white mgx-0">
                                            <div className="row header pdx-10 pdy-10 mgx-0">
                                                <div className="col-3 pdl-20" onClick={() => handleBack()}>
                                                    <i className="fa-solid fa fa-chevron-left"></i>
                                                </div>
                                                <div className="col-6 text-center">
                                                    <span className="name-page">THÀNH CÔNG</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mgt-10 mgx-0">
                                            <div className="pdx-0">
                                                <div className="pdx-10 pdy-12 bg-white">
                                                    <ul className="bs4-order-tracking-mobile ">
                                                        <li id="cart" className="step active"> <div><div className="in-f hei-wid-100"><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/gio_hang_red.png" alt="icon" /></div></div><span className="text-normal-12">Giỏ hàng</span></li>
                                                        <li id="delivery" className="step active"><div><div className="in-f hei-wid-100"><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/giao_hang_red.png" alt="icon" /></div></div><span className="text-normal-12">Giao hàng</span></li>
                                                        <li id="payment" className="step active"> <div><div className="in-f hei-wid-100"><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/thanh_toan_red.png" alt="icon" /></div></div><span className="text-normal-12"> Thanh toán </span></li>
                                                        <li id="complate" className="step active"> <div><div className="in-f hei-wid-100"><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/thanh_cong_red.png" alt="icon" /></div></div><span className="text-normal-12"> Thành công </span> </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ height: 128 }}></div>
                                    <ComplateOrderMobile key="ComplateOrder" />
                                </div>
                            </>
                        default:
                            return null;
                    }
                })()
            }
{
            showLoad ? (
            <div id="myModal" class="mobile-modal-cart">
                <div class="mobile-modal-cart-content">
                    <div className="mobile-modal-cart-title">Chúng tôi đang tìm đối tác vận chuyển...</div>
                    <img src="/static/image/bike.gif" alt="icon" />
                </div>
            </div>
            ):(null)
           }
        </>
    )
}
export default CartItems;